module.exports = __webpack_public_path__ + "img/safe-info-variant.693564a8.svg";